webpackJsonp([114276838955818,60335399758886],{

/***/ 123:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"shortName":"Acclimate"}}},"layoutContext":{}}

/***/ }),

/***/ 241:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(249);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(123);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 416:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
	(function() {
	  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
	
	  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
	    module.exports = function() {
	      return performance.now();
	    };
	  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
	    module.exports = function() {
	      return (getNanoSeconds() - nodeLoadTime) / 1e6;
	    };
	    hrtime = process.hrtime;
	    getNanoSeconds = function() {
	      var hr;
	      hr = hrtime();
	      return hr[0] * 1e9 + hr[1];
	    };
	    moduleLoadTime = getNanoSeconds();
	    upTime = process.uptime() * 1e9;
	    nodeLoadTime = moduleLoadTime - upTime;
	  } else if (Date.now) {
	    module.exports = function() {
	      return Date.now() - loadTime;
	    };
	    loadTime = Date.now();
	  } else {
	    module.exports = function() {
	      return new Date().getTime() - loadTime;
	    };
	    loadTime = new Date().getTime();
	  }
	
	}).call(this);
	
	//# sourceMappingURL=performance-now.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(67)))

/***/ }),

/***/ 469:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(416)
	  , root = typeof window === 'undefined' ? global : window
	  , vendors = ['moz', 'webkit']
	  , suffix = 'AnimationFrame'
	  , raf = root['request' + suffix]
	  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]
	
	for(var i = 0; !raf && i < vendors.length; i++) {
	  raf = root[vendors[i] + 'Request' + suffix]
	  caf = root[vendors[i] + 'Cancel' + suffix]
	      || root[vendors[i] + 'CancelRequest' + suffix]
	}
	
	// Some versions of FF have rAF but not cAF
	if(!raf || !caf) {
	  var last = 0
	    , id = 0
	    , queue = []
	    , frameDuration = 1000 / 60
	
	  raf = function(callback) {
	    if(queue.length === 0) {
	      var _now = now()
	        , next = Math.max(0, frameDuration - (_now - last))
	      last = next + _now
	      setTimeout(function() {
	        var cp = queue.slice(0)
	        // Clear queue here to prevent
	        // callbacks from appending listeners
	        // to the current frame's queue
	        queue.length = 0
	        for(var i = 0; i < cp.length; i++) {
	          if(!cp[i].cancelled) {
	            try{
	              cp[i].callback(last)
	            } catch(e) {
	              setTimeout(function() { throw e }, 0)
	            }
	          }
	        }
	      }, Math.round(next))
	    }
	    queue.push({
	      handle: ++id,
	      callback: callback,
	      cancelled: false
	    })
	    return id
	  }
	
	  caf = function(handle) {
	    for(var i = 0; i < queue.length; i++) {
	      if(queue[i].handle === handle) {
	        queue[i].cancelled = true
	      }
	    }
	  }
	}
	
	module.exports = function(fn) {
	  // Wrap in a new function to prevent
	  // `cancel` potentially being assigned
	  // to the native rAF function
	  return raf.call(root, fn)
	}
	module.exports.cancel = function() {
	  caf.apply(root, arguments)
	}
	module.exports.polyfill = function(object) {
	  if (!object) {
	    object = root;
	  }
	  object.requestAnimationFrame = raf
	  object.cancelAnimationFrame = caf
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 533:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _shallowequal = __webpack_require__(235);
	
	var _shallowequal2 = _interopRequireDefault(_shallowequal);
	
	var _raf = __webpack_require__(469);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _shouldUpdate2 = __webpack_require__(534);
	
	var _shouldUpdate3 = _interopRequireDefault(_shouldUpdate2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // eslint-disable-line import/no-unresolved
	
	
	var noop = function noop() {};
	
	var Headroom = function (_Component) {
	  _inherits(Headroom, _Component);
	
	  function Headroom(props) {
	    _classCallCheck(this, Headroom);
	
	    // Class variables.
	    var _this = _possibleConstructorReturn(this, (Headroom.__proto__ || Object.getPrototypeOf(Headroom)).call(this, props));
	
	    _this.setRef = function (ref) {
	      return _this.inner = ref;
	    };
	
	    _this.setHeightOffset = function () {
	      _this.setState({
	        height: _this.inner.offsetHeight
	      });
	      _this.resizeTicking = false;
	    };
	
	    _this.getScrollY = function () {
	      if (_this.props.parent().pageYOffset !== void 0) {
	        return _this.props.parent().pageYOffset;
	      } else if (_this.props.parent().scrollTop !== void 0) {
	        return _this.props.parent().scrollTop;
	      } else {
	        return (document.documentElement || document.body.parentNode || document.body).scrollTop;
	      }
	    };
	
	    _this.getViewportHeight = function () {
	      return window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
	    };
	
	    _this.getDocumentHeight = function () {
	      var body = document.body;
	      var documentElement = document.documentElement;
	
	      return Math.max(body.scrollHeight, documentElement.scrollHeight, body.offsetHeight, documentElement.offsetHeight, body.clientHeight, documentElement.clientHeight);
	    };
	
	    _this.getElementPhysicalHeight = function (elm) {
	      return Math.max(elm.offsetHeight, elm.clientHeight);
	    };
	
	    _this.getElementHeight = function (elm) {
	      return Math.max(elm.scrollHeight, elm.offsetHeight, elm.clientHeight);
	    };
	
	    _this.getScrollerPhysicalHeight = function () {
	      var parent = _this.props.parent();
	
	      return parent === window || parent === document.body ? _this.getViewportHeight() : _this.getElementPhysicalHeight(parent);
	    };
	
	    _this.getScrollerHeight = function () {
	      var parent = _this.props.parent();
	
	      return parent === window || parent === document.body ? _this.getDocumentHeight() : _this.getElementHeight(parent);
	    };
	
	    _this.isOutOfBound = function (currentScrollY) {
	      var pastTop = currentScrollY < 0;
	
	      var scrollerPhysicalHeight = _this.getScrollerPhysicalHeight();
	      var scrollerHeight = _this.getScrollerHeight();
	
	      var pastBottom = currentScrollY + scrollerPhysicalHeight > scrollerHeight;
	
	      return pastTop || pastBottom;
	    };
	
	    _this.handleScroll = function () {
	      if (!_this.scrollTicking) {
	        _this.scrollTicking = true;
	        (0, _raf2.default)(_this.update);
	      }
	    };
	
	    _this.handleResize = function () {
	      if (!_this.resizeTicking) {
	        _this.resizeTicking = true;
	        (0, _raf2.default)(_this.setHeightOffset);
	      }
	    };
	
	    _this.unpin = function () {
	      _this.props.onUnpin();
	
	      _this.setState({
	        translateY: '-100%',
	        className: 'headroom headroom--unpinned',
	        state: 'unpinned'
	      });
	    };
	
	    _this.pin = function () {
	      _this.props.onPin();
	
	      _this.setState({
	        translateY: 0,
	        className: 'headroom headroom--pinned',
	        state: 'pinned'
	      });
	    };
	
	    _this.unfix = function () {
	      _this.props.onUnfix();
	
	      _this.setState({
	        translateY: 0,
	        className: 'headroom headroom--unfixed',
	        state: 'unfixed'
	      });
	    };
	
	    _this.update = function () {
	      _this.currentScrollY = _this.getScrollY();
	
	      if (!_this.isOutOfBound(_this.currentScrollY)) {
	        var _shouldUpdate = (0, _shouldUpdate3.default)(_this.lastKnownScrollY, _this.currentScrollY, _this.props, _this.state),
	            action = _shouldUpdate.action;
	
	        if (action === 'pin') {
	          _this.pin();
	        } else if (action === 'unpin') {
	          _this.unpin();
	        } else if (action === 'unfix') {
	          _this.unfix();
	        }
	      }
	
	      _this.lastKnownScrollY = _this.currentScrollY;
	      _this.scrollTicking = false;
	    };
	
	    _this.currentScrollY = 0;
	    _this.lastKnownScrollY = 0;
	    _this.scrollTicking = false;
	    _this.resizeTicking = false;
	    _this.state = {
	      state: 'unfixed',
	      translateY: 0,
	      className: 'headroom headroom--unfixed'
	    };
	    return _this;
	  }
	
	  _createClass(Headroom, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setHeightOffset();
	      if (!this.props.disable) {
	        this.props.parent().addEventListener('scroll', this.handleScroll);
	
	        if (this.props.calcHeightOnResize) {
	          this.props.parent().addEventListener('resize', this.handleResize);
	        }
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.disable && !this.props.disable) {
	        this.unfix();
	        this.props.parent().removeEventListener('scroll', this.handleScroll);
	        this.props.parent().removeEventListener('resize', this.handleResize);
	      } else if (!nextProps.disable && this.props.disable) {
	        this.props.parent().addEventListener('scroll', this.handleScroll);
	
	        if (this.props.calcHeightOnResize) {
	          this.props.parent().addEventListener('resize', this.handleResize);
	        }
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return !(0, _shallowequal2.default)(this.props, nextProps) || !(0, _shallowequal2.default)(this.state, nextState);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      // If children have changed, remeasure height.
	      if (prevProps.children !== this.props.children) {
	        this.setHeightOffset();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.parent().removeEventListener('scroll', this.handleScroll);
	      window.removeEventListener('scroll', this.handleScroll);
	      this.props.parent().removeEventListener('resize', this.handleResize);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          userClassName = _props.className,
	          divProps = _objectWithoutProperties(_props, ['className']);
	
	      delete divProps.onUnpin;
	      delete divProps.onPin;
	      delete divProps.onUnfix;
	      delete divProps.disableInlineStyles;
	      delete divProps.disable;
	      delete divProps.parent;
	      delete divProps.children;
	      delete divProps.upTolerance;
	      delete divProps.downTolerance;
	      delete divProps.pinStart;
	      delete divProps.calcHeightOnResize;
	
	      var style = divProps.style,
	          wrapperStyle = divProps.wrapperStyle,
	          rest = _objectWithoutProperties(divProps, ['style', 'wrapperStyle']);
	
	      var innerStyle = {
	        position: this.props.disable || this.state.state === 'unfixed' ? 'relative' : 'fixed',
	        top: 0,
	        left: 0,
	        right: 0,
	        zIndex: 1,
	        WebkitTransform: 'translate3D(0, ' + this.state.translateY + ', 0)',
	        MsTransform: 'translate3D(0, ' + this.state.translateY + ', 0)',
	        transform: 'translate3D(0, ' + this.state.translateY + ', 0)'
	      };
	
	      var className = this.state.className;
	
	      // Don't add css transitions until after we've done the initial
	      // negative transform when transitioning from 'unfixed' to 'unpinned'.
	      // If we don't do this, the header will flash into view temporarily
	      // while it transitions from 0 — -100%.
	      if (this.state.state !== 'unfixed') {
	        innerStyle = _extends({}, innerStyle, {
	          WebkitTransition: 'all .2s ease-in-out',
	          MozTransition: 'all .2s ease-in-out',
	          OTransition: 'all .2s ease-in-out',
	          transition: 'all .2s ease-in-out'
	        });
	        className += ' headroom--scrolled';
	      }
	
	      if (!this.props.disableInlineStyles) {
	        innerStyle = _extends({}, innerStyle, style);
	      } else {
	        innerStyle = style;
	      }
	
	      var wrapperStyles = _extends({}, wrapperStyle, {
	        height: this.state.height ? this.state.height : null
	      });
	
	      var wrapperClassName = userClassName ? userClassName + ' headroom-wrapper' : 'headroom-wrapper';
	
	      return _react2.default.createElement(
	        'div',
	        { style: wrapperStyles, className: wrapperClassName },
	        _react2.default.createElement(
	          'div',
	          _extends({
	            ref: this.setRef
	          }, rest, {
	            style: innerStyle,
	            className: className
	          }),
	          this.props.children
	        )
	      );
	    }
	  }]);
	
	  return Headroom;
	}(_react.Component);
	
	Headroom.propTypes = {
	  className: _propTypes2.default.string,
	  parent: _propTypes2.default.func,
	  children: _propTypes2.default.any.isRequired,
	  disableInlineStyles: _propTypes2.default.bool,
	  disable: _propTypes2.default.bool,
	  upTolerance: _propTypes2.default.number,
	  downTolerance: _propTypes2.default.number,
	  onPin: _propTypes2.default.func,
	  onUnpin: _propTypes2.default.func,
	  onUnfix: _propTypes2.default.func,
	  wrapperStyle: _propTypes2.default.object,
	  pinStart: _propTypes2.default.number,
	  style: _propTypes2.default.object,
	  calcHeightOnResize: _propTypes2.default.bool
	};
	Headroom.defaultProps = {
	  parent: function parent() {
	    return window;
	  },
	  disableInlineStyles: false,
	  disable: false,
	  upTolerance: 5,
	  downTolerance: 0,
	  onPin: noop,
	  onUnpin: noop,
	  onUnfix: noop,
	  wrapperStyle: {},
	  pinStart: 0,
	  calcHeightOnResize: true
	};
	exports.default = Headroom;

/***/ }),

/***/ 534:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  var lastKnownScrollY = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
	  var currentScrollY = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
	  var props = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
	  var state = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
	
	  var scrollDirection = currentScrollY >= lastKnownScrollY ? 'down' : 'up';
	  var distanceScrolled = Math.abs(currentScrollY - lastKnownScrollY);
	
	  // We're disabled
	  if (props.disable) {
	    return {
	      action: 'none',
	      scrollDirection: scrollDirection,
	      distanceScrolled: distanceScrolled
	      // We're at the top and not fixed yet.
	    };
	  } else if (currentScrollY <= props.pinStart && state.state !== 'unfixed') {
	    return {
	      action: 'unfix',
	      scrollDirection: scrollDirection,
	      distanceScrolled: distanceScrolled
	      // We're unfixed and headed down. Carry on.
	    };
	  } else if (currentScrollY <= state.height && scrollDirection === 'down' && state.state === 'unfixed') {
	    return {
	      action: 'none',
	      scrollDirection: scrollDirection,
	      distanceScrolled: distanceScrolled
	      // We're past the header and scrolling down.
	      // We transition to "unpinned" if necessary.
	    };
	  } else if (scrollDirection === 'down' && ['pinned', 'unfixed'].indexOf(state.state) >= 0 && currentScrollY > state.height + props.pinStart && distanceScrolled > props.downTolerance) {
	    return {
	      action: 'unpin',
	      scrollDirection: scrollDirection,
	      distanceScrolled: distanceScrolled
	      // We're scrolling up, we transition to "pinned"
	    };
	  } else if (scrollDirection === 'up' && distanceScrolled > props.upTolerance && ['pinned', 'unfixed'].indexOf(state.state) < 0) {
	    return {
	      action: 'pin',
	      scrollDirection: scrollDirection,
	      distanceScrolled: distanceScrolled
	      // We're scrolling up, and inside the header.
	      // We transition to pin regardless of upTolerance
	    };
	  } else if (scrollDirection === 'up' && currentScrollY <= state.height && ['pinned', 'unfixed'].indexOf(state.state) < 0) {
	    return {
	      action: 'pin',
	      scrollDirection: scrollDirection,
	      distanceScrolled: distanceScrolled
	    };
	  } else {
	    return {
	      action: 'none',
	      scrollDirection: scrollDirection,
	      distanceScrolled: distanceScrolled
	    };
	  }
	};

/***/ }),

/***/ 33:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  text-decoration: none;\n  margin-top: 10px;\n  border: none;\n  color: ", ";\n  font-size: 16px;\n  background: ", ";\n  padding: 10px;\n  border-radius: 5px;\n  display: inline-block;\n  &:after {\n    content: \"\u2192\";\n    display: inline-block;\n    margin-left: 5px;\n    transition: all 0.3s ease;\n  }\n  transition: all 0.3s ease;\n  &:hover {\n    background: ", ";\n  }\n  &:hover:after {\n    transform: scaleY(1.5);\n  }\n"], ["\n  text-decoration: none;\n  margin-top: 10px;\n  border: none;\n  color: ", ";\n  font-size: 16px;\n  background: ", ";\n  padding: 10px;\n  border-radius: 5px;\n  display: inline-block;\n  &:after {\n    content: \"\\u2192\";\n    display: inline-block;\n    margin-left: 5px;\n    transition: all 0.3s ease;\n  }\n  transition: all 0.3s ease;\n  &:hover {\n    background: ", ";\n  }\n  &:hover:after {\n    transform: scaleY(1.5);\n  }\n"]);
	
	var _styledComponents = __webpack_require__(8);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyLink = __webpack_require__(25);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _polished = __webpack_require__(16);
	
	var _theme = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	exports.default = (0, _styledComponents2.default)(_gatsbyLink2.default)(_templateObject, _theme.colors.white, _theme.colors.secondary, (0, _polished.lighten)(0.04, _theme.colors.secondary));
	module.exports = exports["default"];

/***/ }),

/***/ 245:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: space-between;\n  .cls-1 {\n    fill: ", ";\n  }\n  svg {\n    flex: 1 0;\n    height: 360px;\n    margin: -41px -30px -40px 0;\n  }\n  > div {\n    flex: 1 0;\n  }\n  p {\n    color: ", ";\n  }\n"], ["\n  display: flex;\n  justify-content: space-between;\n  .cls-1 {\n    fill: ", ";\n  }\n  svg {\n    flex: 1 0;\n    height: 360px;\n    margin: -41px -30px -40px 0;\n  }\n  > div {\n    flex: 1 0;\n  }\n  p {\n    color: ", ";\n  }\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(8);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _polished = __webpack_require__(16);
	
	var _theme = __webpack_require__(6);
	
	var _SectionWrapper = __webpack_require__(24);
	
	var _SectionWrapper2 = _interopRequireDefault(_SectionWrapper);
	
	var _CallToActionButton = __webpack_require__(33);
	
	var _CallToActionButton2 = _interopRequireDefault(_CallToActionButton);
	
	var _halfLogo = __webpack_require__(576);
	
	var _halfLogo2 = _interopRequireDefault(_halfLogo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var CTAContainer = _styledComponents2.default.div(_templateObject, (0, _polished.lighten)(0.2, _theme.colors.dark), _theme.colors.light);
	
	exports.default = function () {
	  return _react2.default.createElement(
	    _SectionWrapper2.default,
	    { backgroundColor: _theme.colors.dark, fontColor: _theme.colors.white },
	    _react2.default.createElement(
	      CTAContainer,
	      null,
	      _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "h1",
	          null,
	          "Partner with us"
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Have questions? Reach out to a technology strategy expert. Schedule a free conslutation to explore how your organization can acclimate."
	        ),
	        _react2.default.createElement(
	          _CallToActionButton2.default,
	          { to: "/contact" },
	          "Get in touch"
	        )
	      ),
	      _react2.default.createElement(_halfLogo2.default, null)
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 246:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  margin-bottom: 20px;\n  svg {\n    width: 40px;\n    height: 40px;\n    margin-right: 10px;\n    .cls-1 {\n      fill: ", ";\n    }\n    #a2 {\n      fill: ", ";\n    }\n    #a3 {\n      fill: ", ";\n    }\n    transition: all 0.4s ease;\n    &:hover {\n      transform: rotate(72deg);\n    }\n  }\n  a {\n    color: ", ";\n    text-decoration: none;\n    transition: all 0.3s ease;\n    :hover {\n      color: ", ";\n    }\n  h2 {\n    margin: 0;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  margin-bottom: 20px;\n  svg {\n    width: 40px;\n    height: 40px;\n    margin-right: 10px;\n    .cls-1 {\n      fill: ", ";\n    }\n    #a2 {\n      fill: ", ";\n    }\n    #a3 {\n      fill: ", ";\n    }\n    transition: all 0.4s ease;\n    &:hover {\n      transform: rotate(72deg);\n    }\n  }\n  a {\n    color: ", ";\n    text-decoration: none;\n    transition: all 0.3s ease;\n    :hover {\n      color: ", ";\n    }\n  h2 {\n    margin: 0;\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  > a {\n    color: ", ";\n    text-decoration: none;\n    transition: all 0.3s ease;\n    :hover {\n      color: ", ";\n    }\n    display: block;\n    margin-bottom: 10px;\n  }\n"], ["\n  > a {\n    color: ", ";\n    text-decoration: none;\n    transition: all 0.3s ease;\n    :hover {\n      color: ", ";\n    }\n    display: block;\n    margin-bottom: 10px;\n  }\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  margin-top: 15px;\n  align-items: flex-start;\n  > div {\n    flex: 1 0 30%;\n  }\n  @media(max-width: 850px) {\n    flex-direction: column;\n  }\n"], ["\n  display: flex;\n  margin-top: 15px;\n  align-items: flex-start;\n  > div {\n    flex: 1 0 30%;\n  }\n  @media(max-width: 850px) {\n    flex-direction: column;\n  }\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  color: ", ";\n  font-size: 12px;\n  a {\n    color: ", ";\n    text-decoration: none;\n    transition: all 0.3s ease;\n    :hover {\n      color: ", ";\n    }\n  }\n"], ["\n  color: ", ";\n  font-size: 12px;\n  a {\n    color: ", ";\n    text-decoration: none;\n    transition: all 0.3s ease;\n    :hover {\n      color: ", ";\n    }\n  }\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(8);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyLink = __webpack_require__(25);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _polished = __webpack_require__(16);
	
	var _theme = __webpack_require__(6);
	
	var _SectionWrapper = __webpack_require__(24);
	
	var _SectionWrapper2 = _interopRequireDefault(_SectionWrapper);
	
	var _logo = __webpack_require__(236);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var LogoContainer = _styledComponents2.default.div(_templateObject, (0, _polished.lighten)(0.2, _theme.colors.black), _theme.colors.secondary, _theme.colors.primary, (0, _polished.lighten)(0.2, _theme.colors.black), (0, _polished.lighten)(0.3, _theme.colors.black));
	
	var FooterContent = _styledComponents2.default.div(_templateObject2, (0, _polished.lighten)(0.2, _theme.colors.black), (0, _polished.lighten)(0.3, _theme.colors.black));
	
	var FooterContainer = _styledComponents2.default.div(_templateObject3);
	
	var Copyright = _styledComponents2.default.div(_templateObject4, (0, _polished.lighten)(0.2, _theme.colors.black), (0, _polished.lighten)(0.2, _theme.colors.black), (0, _polished.lighten)(0.3, _theme.colors.black));
	
	exports.default = function () {
	  return _react2.default.createElement(
	    _SectionWrapper2.default,
	    {
	      backgroundColor: _theme.colors.black,
	      fontColor: (0, _polished.lighten)(0.2, _theme.colors.black)
	    },
	    _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement(
	        FooterContainer,
	        null,
	        _react2.default.createElement(
	          LogoContainer,
	          null,
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: "/" },
	            _react2.default.createElement(_logo2.default, null)
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: "/" },
	            _react2.default.createElement(
	              "h2",
	              null,
	              "Acclimate"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          FooterContent,
	          null,
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: "/services" },
	            "Services"
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: "/process" },
	            "Process"
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: "/industries" },
	            "Industries"
	          )
	        ),
	        _react2.default.createElement(
	          FooterContent,
	          null,
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: "/team" },
	            "Team"
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: "/careers" },
	            "Careers"
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: "/contact" },
	            "Contact"
	          )
	        )
	      ),
	      _react2.default.createElement(
	        FooterContainer,
	        null,
	        _react2.default.createElement("div", null),
	        _react2.default.createElement(
	          Copyright,
	          null,
	          _react2.default.createElement(
	            "p",
	            null,
	            "\xA9 Acclimate ",
	            new Date().getFullYear(),
	            " | ",
	            _react2.default.createElement(
	              "a",
	              null,
	              "Terms of use"
	            ),
	            " | ",
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: "/privacypolicy" },
	              "Privacy policy"
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            null,
	            "Icons from",
	            " ",
	            _react2.default.createElement(
	              "a",
	              { href: "https://www.flaticon.com/", title: "Flaticon" },
	              "flaticon.com"
	            ),
	            " ",
	            "licensed under",
	            " ",
	            _react2.default.createElement(
	              "a",
	              {
	                href: "http://creativecommons.org/licenses/by/3.0/",
	                title: "Creative Commons BY 3.0",
	                target: "_blank"
	              },
	              "CC 3.0 BY"
	            )
	          )
	        ),
	        _react2.default.createElement("div", null)
	      )
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 248:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  width: 100vw;\n  z-index: 2;\n  background-color: ", ";\n"], ["\n  width: 100vw;\n  z-index: 2;\n  background-color: ", ";\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  max-width: 960px;\n  margin: auto;\n  height: 65px;\n  justify-content: space-between;\n  border-bottom: 1px solid ", ";\n"], ["\n  display: flex;\n  max-width: 960px;\n  margin: auto;\n  height: 65px;\n  justify-content: space-between;\n  border-bottom: 1px solid ", ";\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  padding-left: 10px;\n"], ["\n  display: flex;\n  align-items: center;\n  padding-left: 10px;\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  font-weight: 700;\n  text-decoration: none;\n  color: #ffffff;\n  font-size: 18pt;\n  @media (max-width: 500px) {\n    font-size: 14pt;\n  }\n"], ["\n  font-weight: 700;\n  text-decoration: none;\n  color: #ffffff;\n  font-size: 18pt;\n  @media (max-width: 500px) {\n    font-size: 14pt;\n  }\n"]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  font-size: 12pt;\n  @media (max-width: 500px) {\n    font-size: 10pt;\n  }\n  a {\n    color: ", "\n    text-decoration: none;\n  }\n"], ["\n  display: flex;\n  font-size: 12pt;\n  @media (max-width: 500px) {\n    font-size: 10pt;\n  }\n  a {\n    color: ", "\n    text-decoration: none;\n  }\n"]),
	    _templateObject6 = _taggedTemplateLiteralLoose(["\n  svg {\n    margin-right: 10px;\n    width: 40px;\n    height: 40px;\n    transition: all 0.4s ease;\n    .cls-1 {\n      fill: ", ";\n    }\n    &:hover {\n      transform: rotate(72deg);\n    }\n    #a2 {\n      fill: ", ";\n    }\n    #a3 {\n      fill: ", ";\n    }\n  }\n"], ["\n  svg {\n    margin-right: 10px;\n    width: 40px;\n    height: 40px;\n    transition: all 0.4s ease;\n    .cls-1 {\n      fill: ", ";\n    }\n    &:hover {\n      transform: rotate(72deg);\n    }\n    #a2 {\n      fill: ", ";\n    }\n    #a3 {\n      fill: ", ";\n    }\n  }\n"]),
	    _templateObject7 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  padding: 0 10px;\n  position: relative;\n  transition: all 0.1s ease;\n  &:hover {\n    background: ", ";\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  padding: 0 10px;\n  position: relative;\n  transition: all 0.1s ease;\n  &:hover {\n    background: ", ";\n  }\n"]),
	    _templateObject8 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  padding: 0 10px;\n  position: relative;\n  &:after {\n    content: \">\";\n    color: ", ";\n    display: inline-block;\n    margin-left: 5px;\n    transition: all 0.1s ease;\n  }\n  transition: all 0.1s ease;\n  @media (hover: none) {\n    background: ", ";\n    &:after {\n      transform: ", ";\n    }\n  }\n  @media (hover: hover) {\n    &:hover {\n      background: ", ";\n    }\n    &:hover:after {\n      transform: rotate(90deg);\n    }\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  padding: 0 10px;\n  position: relative;\n  &:after {\n    content: \"\\u003e\";\n    color: ", ";\n    display: inline-block;\n    margin-left: 5px;\n    transition: all 0.1s ease;\n  }\n  transition: all 0.1s ease;\n  @media (hover: none) {\n    background: ", ";\n    &:after {\n      transform: ", ";\n    }\n  }\n  @media (hover: hover) {\n    &:hover {\n      background: ", ";\n    }\n    &:hover:after {\n      transform: rotate(90deg);\n    }\n  }\n"]),
	    _templateObject9 = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  flex-direction: column;\n  z-index: -1;\n  left: 0;\n  top: 65px;\n  width: 100%;\n  background: ", ";\n  border-radius: 0 0 5px 5px;\n  @media (hover: none) {\n    display: ", ";\n    visibility: ", ";\n    opacity: ", ";\n  }\n  @media (hover: hover) {\n    display: none;\n    visibility: hidden;\n    opacity: 0;\n    ", ":hover & {\n      display: flex;\n      visibility: visible;\n      opacity: 1;\n    }\n  }\n"], ["\n  position: absolute;\n  flex-direction: column;\n  z-index: -1;\n  left: 0;\n  top: 65px;\n  width: 100%;\n  background: ", ";\n  border-radius: 0 0 5px 5px;\n  @media (hover: none) {\n    display: ", ";\n    visibility: ", ";\n    opacity: ", ";\n  }\n  @media (hover: hover) {\n    display: none;\n    visibility: hidden;\n    opacity: 0;\n    ", ":hover & {\n      display: flex;\n      visibility: visible;\n      opacity: 1;\n    }\n  }\n"]),
	    _templateObject10 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  text-decoration: none;\n  height: 35px;\n  padding-left: 10px;\n  border-top: 1px solid ", ";\n  font-size: 10pt;\n  @media (max-width: 500px) {\n    font-size: 8pt;\n  }\n  &:hover {\n    background: ", ";\n  }\n  &:last-of-type {\n    border-radius: 0 0 5px 5px;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  text-decoration: none;\n  height: 35px;\n  padding-left: 10px;\n  border-top: 1px solid ", ";\n  font-size: 10pt;\n  @media (max-width: 500px) {\n    font-size: 8pt;\n  }\n  &:hover {\n    background: ", ";\n  }\n  &:last-of-type {\n    border-radius: 0 0 5px 5px;\n  }\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(25);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(8);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _polished = __webpack_require__(16);
	
	var _theme = __webpack_require__(6);
	
	var _logo = __webpack_require__(236);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Wrapper = _styledComponents2.default.div(_templateObject, _theme.colors.dark);
	
	var Nav = _styledComponents2.default.nav(_templateObject2, (0, _polished.lighten)(0.05, _theme.colors.dark));
	
	var Left = _styledComponents2.default.div(_templateObject3);
	
	var Title = (0, _styledComponents2.default)(_gatsbyLink2.default)(_templateObject4);
	
	var Right = _styledComponents2.default.div(_templateObject5, _theme.colors.white);
	
	var LogoLink = (0, _styledComponents2.default)(_gatsbyLink2.default)(_templateObject6, _theme.colors.light, _theme.colors.secondary, _theme.colors.primary);
	
	var Insights = _styledComponents2.default.div(_templateObject7, (0, _polished.lighten)(0.05, _theme.colors.dark));
	
	var DropItem = _styledComponents2.default.div(_templateObject8, _theme.colors.white, function (props) {
	  return props.toggle ? _theme.colors.dark : (0, _polished.lighten)(0.05, _theme.colors.dark);
	}, function (props) {
	  return props.toggle ? "rotate(0deg)" : "rotate(90deg)";
	}, (0, _polished.lighten)(0.05, _theme.colors.dark));
	
	var Drop = _styledComponents2.default.div(_templateObject9, _theme.colors.dark, function (props) {
	  return props.toggle ? "none" : "flex";
	}, function (props) {
	  return props.toggle ? "hidden" : "visible";
	}, function (props) {
	  return props.toggle ? 0 : 1;
	}, DropItem);
	
	var SLink = (0, _styledComponents2.default)(_gatsbyLink2.default)(_templateObject10, (0, _polished.lighten)(0.05, _theme.colors.dark), (0, _polished.lighten)(0.05, _theme.colors.dark));
	
	var Navigation = function (_React$Component) {
	  _inherits(Navigation, _React$Component);
	
	  function Navigation(props) {
	    _classCallCheck(this, Navigation);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      aboutToggle: true,
	      companyToggle: true
	    };
	    _this.aboutHandler = _this.aboutHandler.bind(_this);
	    _this.companyHandler = _this.companyHandler.bind(_this);
	    return _this;
	  }
	
	  Navigation.prototype.aboutHandler = function aboutHandler() {
	    this.setState(function (prevState) {
	      return {
	        aboutToggle: !prevState.aboutToggle,
	        companyToggle: true
	      };
	    });
	  };
	
	  Navigation.prototype.companyHandler = function companyHandler() {
	    this.setState(function (prevState) {
	      return {
	        aboutToggle: true,
	        companyToggle: !prevState.companyToggle
	      };
	    });
	  };
	
	  Navigation.prototype.render = function render() {
	    return _react2.default.createElement(
	      Wrapper,
	      null,
	      _react2.default.createElement(
	        Nav,
	        null,
	        _react2.default.createElement(
	          Left,
	          null,
	          _react2.default.createElement(
	            LogoLink,
	            { to: "/" },
	            _react2.default.createElement(_logo2.default, null)
	          ),
	          _react2.default.createElement(
	            Title,
	            { to: "/" },
	            "Acclimate"
	          )
	        ),
	        _react2.default.createElement(
	          Right,
	          null,
	          _react2.default.createElement(
	            DropItem,
	            {
	              onClick: this.aboutHandler,
	              toggle: this.state.aboutToggle
	            },
	            _react2.default.createElement(
	              "a",
	              { href: "#" },
	              "About"
	            ),
	            _react2.default.createElement(
	              Drop,
	              { toggle: this.state.aboutToggle },
	              _react2.default.createElement(
	                SLink,
	                { to: "/services" },
	                "Services"
	              ),
	              _react2.default.createElement(
	                SLink,
	                { to: "/process" },
	                "Process"
	              ),
	              _react2.default.createElement(
	                SLink,
	                { to: "/industries" },
	                "Industries"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            DropItem,
	            {
	              onClick: this.companyHandler,
	              toggle: this.state.companyToggle
	            },
	            _react2.default.createElement(
	              "a",
	              { href: "#" },
	              "Company"
	            ),
	            _react2.default.createElement(
	              Drop,
	              { toggle: this.state.companyToggle },
	              _react2.default.createElement(
	                SLink,
	                { to: "/team" },
	                "Team"
	              ),
	              _react2.default.createElement(
	                SLink,
	                { to: "/careers" },
	                "Careers"
	              ),
	              _react2.default.createElement(
	                SLink,
	                { to: "/contact" },
	                "Contact"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            Insights,
	            null,
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: "/insights" },
	              "Insights"
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Navigation;
	}(_react2.default.Component);
	
	exports.default = Navigation;
	module.exports = exports["default"];

/***/ }),

/***/ 576:
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function HalfLogo (props) {
	    return React.createElement("svg",props,[React.createElement("metadata",{"key":0},React.createElement("x:xmpmeta",{"xmlnsX":"adobe:ns:meta/","xXmptk":"Adobe XMP Core 5.6-c138 79.159824, 2016/09/14-01:09:01        "},React.createElement("rdf:RDF",{"xmlnsRdf":"http://www.w3.org/1999/02/22-rdf-syntax-ns#"},React.createElement("rdf:Description",{"rdfAbout":""})))),React.createElement("defs",{"key":1},React.createElement("style",null,"\n      .cls-1 {\n        fill: #4f5f6c;\n        fill-rule: evenodd;\n      }\n    ")),React.createElement("path",{"id":"a7","className":"cls-1","d":"M254.4,540.609c-10-7.259-20.778-6.027-37.33,6.17s-25.988,35.988-62.322,9.618,6.014,4.439-28.854-20.941-15.706-42.252-9.645-62.474,3.692-29.957-6.118-37.077ZM112,536H268v39H112V536Z","key":2}),React.createElement("path",{"id":"a8","className":"cls-1","d":"M106.875,435.509c-3.821-11.746-13.264-17.076-33.831-16.927s-42.2,13.856-56.08-28.811,2.254,7.123-11.021-33.883,12.156-43.4,28.959-56.2,20.614-22.069,16.867-33.589Z","key":3}),React.createElement("path",{"id":"a9","className":"cls-1","d":"M51.8,264.641c3.821-11.746-.682-21.6-17.409-33.558S-7.9,217.514,5.975,174.847,3.607,181.932,17,140.964,52.371,112.986,73.5,112.5s29.664-5.75,33.411-17.271Z","key":4}),React.createElement("path",{"id":"a10","className":"cls-1","d":"M105.977,94.78c10-7.26,12.16-17.878,5.662-37.371S85.406,21.6,121.74-4.772,115.655-.43,150.594-25.713s45.081-1.864,62.461,10.143S240.437-2.8,250.247-9.925ZM100-41H267V-1H100V-41Z","key":5})]);
	}
	
	HalfLogo.defaultProps = {"width":"252","height":"535","viewBox":"0 0 252 535"};
	
	module.exports = HalfLogo;
	
	HalfLogo.default = HalfLogo;


/***/ }),

/***/ 583:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/logo.93b0dd72.png";

/***/ }),

/***/ 236:
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Logo (props) {
	    return React.createElement("svg",props,[React.createElement("metadata",{"key":0},React.createElement("x:xmpmeta",{"xmlnsX":"adobe:ns:meta/","xXmptk":"Adobe XMP Core 5.6-c138 79.159824, 2016/09/14-01:09:01        "},React.createElement("rdf:RDF",{"xmlnsRdf":"http://www.w3.org/1999/02/22-rdf-syntax-ns#"},React.createElement("rdf:Description",{"rdfAbout":""})))),React.createElement("defs",{"key":1},React.createElement("style",null,"\n      .cls-1 {\n        fill: #4f5f6c;\n        fill-rule: evenodd;\n      }\n    ")),React.createElement("path",{"id":"a1","className":"cls-1","d":"M260.852,75.34c12.36,0,20.351-7.327,26.562-26.92S287.263,4.028,332.159,4.028s-7.476-.06,35.653,0S405.367,29,412.36,48.926,427,75.34,439.118,75.34H260.852Z","key":2}),React.createElement("path",{"id":"a2","className":"cls-1","d":"M437.69,74.419c10,7.263,20.772,6.03,37.317-6.172s25.98-36,62.3-9.622-6.012-4.441,28.844,20.949,15.7,42.269,9.641,62.5-3.69,29.97,6.117,37.093Z","key":3}),React.createElement("path",{"id":"a3","className":"cls-1","d":"M585.161,179.561c3.82,11.751,13.26,17.084,33.82,16.934s42.187-13.861,56.06,28.823-2.253-7.126,11.017,33.9-12.152,43.421-28.948,56.227-20.607,22.078-16.862,33.6C641.551,353.053,583.788,175.335,585.161,179.561Z","key":4}),React.createElement("path",{"id":"a4","className":"cls-1","d":"M640.217,350.5c-3.82,11.751.682,21.612,17.4,33.572s42.28,13.574,28.407,56.258,2.367-7.088-11.018,33.9-35.362,27.988-56.481,28.479-29.653,5.753-33.4,17.278C583.827,523.99,641.59,346.272,640.217,350.5Z","key":5}),React.createElement("path",{"id":"a5","className":"cls-1","d":"M586.059,520.427c-10,7.263-12.156,17.885-5.66,37.387s26.224,35.825-10.1,62.205,6.083-4.344-28.844,20.949-45.065,1.865-62.439-10.147-27.372-12.77-37.179-5.647Z","key":6}),React.createElement("path",{"id":"a6","className":"cls-1","d":"M440.3,624.688c-12.364,0-20.357,7.324-26.571,26.91s0.152,44.374-44.76,44.374,7.478,0.06-35.665,0-37.568-24.961-44.563-44.88-14.642-26.4-26.768-26.4H440.3Z","key":7}),React.createElement("path",{"id":"a7","className":"cls-1","d":"M263.4,625.609c-10-7.259-20.778-6.027-37.33,6.17s-25.988,35.988-62.322,9.618,6.014,4.439-28.854-20.941-15.706-42.252-9.645-62.474,3.692-29.957-6.118-37.077Z","key":8}),React.createElement("path",{"id":"a8","className":"cls-1","d":"M115.875,520.509c-3.821-11.746-13.264-17.076-33.831-16.927s-42.2,13.856-56.08-28.811,2.254,7.123-11.021-33.883,12.156-43.4,28.959-56.2,20.614-22.069,16.867-33.589Z","key":9}),React.createElement("path",{"id":"a9","className":"cls-1","d":"M60.8,349.641c3.821-11.746-.682-21.6-17.409-33.558S1.1,302.514,14.975,259.847,12.607,266.932,26,225.964,61.371,197.986,82.5,197.5s29.664-5.75,33.411-17.271Z","key":10}),React.createElement("path",{"id":"a10","className":"cls-1","d":"M114.977,179.78c10-7.26,12.16-17.878,5.662-37.371S94.406,106.6,130.74,80.228s-6.085,4.342,28.854-20.941,45.081-1.864,62.461,10.143,27.382,12.764,37.192,5.645Z","key":11})]);
	}
	
	Logo.defaultProps = {"width":"700","height":"700","viewBox":"0 0 700 700"};
	
	module.exports = Logo;
	
	Logo.default = Logo;


/***/ }),

/***/ 249:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(19);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactHeadroom = __webpack_require__(533);
	
	var _reactHeadroom2 = _interopRequireDefault(_reactHeadroom);
	
	__webpack_require__(349);
	
	__webpack_require__(348);
	
	var _Navigation = __webpack_require__(248);
	
	var _Navigation2 = _interopRequireDefault(_Navigation);
	
	var _CallToActionSection = __webpack_require__(245);
	
	var _CallToActionSection2 = _interopRequireDefault(_CallToActionSection);
	
	var _Footer = __webpack_require__(246);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _logo = __webpack_require__(583);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var location = _ref.location,
	      children = _ref.children;
	
	  var bottom = void 0;
	  if (location.pathname === "/contact" || location.pathname === "/thanks") {
	    bottom = null;
	  } else if (location.pathname === "/careers") {
	    bottom = _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement(_Footer2.default, null)
	    );
	  } else {
	    bottom = _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement(_CallToActionSection2.default, null),
	      _react2.default.createElement(_Footer2.default, null)
	    );
	  }
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement("link", { rel: "shortcut icon", type: "image/png", href: _logo2.default }),
	      _react2.default.createElement("meta", { charSet: "utf-8" }),
	      _react2.default.createElement("meta", { name: "description", content: "Acclimate Consulting website" }),
	      _react2.default.createElement("meta", { name: "viewport", content: "width=device-width, initial-scale=1.0" })
	    ),
	    _react2.default.createElement(
	      _reactHeadroom2.default,
	      null,
	      _react2.default.createElement(_Navigation2.default, null)
	    ),
	    _react2.default.createElement(
	      "div",
	      null,
	      children()
	    ),
	    bottom,
	    _react2.default.createElement("script", {
	      type: "text/javascript",
	      id: "hs-script-loader",
	      async: true,
	      defer: true,
	      src: "//js.hs-scripts.com/4706986.js"
	    })
	  );
	};
	
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";

/***/ }),

/***/ 348:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 349:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-dbd7b189d1e3ccba9711.js